import { useState } from 'react'
import { NewCardButton } from 'components/CardButtons'
import { useLimitPhysicalCardStore } from 'store'
import UnavailableCardModal from 'components/UnavailableCardModal'
import { useNavigate } from 'react-router-dom'
import { trackEvent } from 'analytics/trackFunctions'
import MinBalanceModal from '../MinBalanceModal'

const cardButtonClasses =
  'text-purple-900 text-xs font-bold shadow-none border-gray-500 border'

const PhysicalCardButtons = ({ card }) => {
  // modal for when there is no plastic cards available
  const [unavailableModal, setUnavailableModal] = useState<boolean>(false)
  // modal for when user doesn't reach the required minimum balance
  const [balanceModalIsOpen, setBalanceModalIsOpen] = useState<boolean>(false)
  const navigate = useNavigate()

  const { card_status: cardStatus } = card
  const shipment = card?.shipping?.status

  const { canRequestCard } = useLimitPhysicalCardStore()

  const noCard =
    cardStatus === 'DISABLED' ||
    (card !== null && Object.keys(card).length === 0)

  function pendingButton() {
    if (shipment === 'DELIVERED') {
      return (
        <NewCardButton
          className={cardButtonClasses}
          onClick={() => {
            navigate('/activar-tarjeta-fisica')
          }}
        >
          <div>
            <p>Ya tengo mi tarjeta física</p>
            <p className='font-medium text-gray-900'>
              Activá tu tarjeta para comenzar a usarla
            </p>
          </div>
        </NewCardButton>
      )
    }

    return (
      <NewCardButton
        className={cardButtonClasses}
        onClick={() => navigate('/seguimiento-tarjeta-fisica')}
      >
        <span>Seguir mi tarjeta física</span>
      </NewCardButton>
    )
  }

  return (
    <>
      {cardStatus === 'PENDING' && pendingButton()}

      {noCard && (
        <>
          <NewCardButton
            onClick={() => {
              // cuando no hay tarjetas disponibles:
              // setUnavailableModal(true)
              if (canRequestCard) {
                navigate('/direccion-tarjeta-fisica')
              } else {
                setBalanceModalIsOpen(true)
              }
            }}
            className={cardButtonClasses}
          >
            <span>Quiero mi tarjeta física</span>
          </NewCardButton>
          <UnavailableCardModal
            setIsOpen={setUnavailableModal}
            isOpen={unavailableModal}
          />
        </>
      )}

      {cardStatus === 'ACTIVE' && shipment === 'DELIVERED' && (
        <NewCardButton
          onClick={() => {
            trackEvent({ eventName: 'bille_boton_tarjeta_extra_cash' })
            navigate('/extraer-dinero')
          }}
          className={cardButtonClasses}
        >
          <span>Extraer dinero</span>
        </NewCardButton>
      )}

      <MinBalanceModal
        isOpen={balanceModalIsOpen}
        setIsOpen={setBalanceModalIsOpen}
      />
    </>
  )
}

export default PhysicalCardButtons
